// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__rhYup","info":"UpdateTermsInfo_info__baB_9"};